import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const GERMAN_LANDLINE_NSN_REGEX = /^(?:32\d{9,11}|49[1-6]\d{10}|322\d{6}|49[0-7]\d{3,9}|(?:[34]0|[68]9)\d{3,13}|(?:2(?:0[1-689]|[1-3569]\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\d|[589][0-7]|6[0-8]|7[0-467]))\d{3,12})$/;
export const GERMAN_TOLL_FREE_NSN_REGEX = /^800\d{7,12}$/;
export const GERMAN_SHARED_COST_NSN_REGEX = /^180[1-9]\d{6}$/;
export const GERMAN_MOBILE_REGEX = /^01[5-7]\d{1,2}\s?\d{7,9}$/;

function digitsOnly(value: string): string {
  return String(value || '').replace(/\D/g, '');
}

export function isValidGermanLandlineNumber(value: string): boolean {
  const input = String(value || '').trim();
  if (!/^[\d\s]+$/.test(input)) {
    return false;
  }

  const digits = digitsOnly(input);
  if (!digits.startsWith('0') || /^01[5-7]/.test(digits)) {
    return false;
  }

  const nationalSignificantNumber = digits.slice(1);
  return GERMAN_LANDLINE_NSN_REGEX.test(nationalSignificantNumber)
    || GERMAN_TOLL_FREE_NSN_REGEX.test(nationalSignificantNumber)
    || GERMAN_SHARED_COST_NSN_REGEX.test(nationalSignificantNumber);
}

export function isValidGermanPhoneNumber(value: string): boolean {
  return isValidGermanLandlineNumber(value) || GERMAN_MOBILE_REGEX.test(String(value || '').trim());
}

export function isValidGermanMobileNumber(value: string): boolean {
  return GERMAN_MOBILE_REGEX.test(String(value || '').trim());
}

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }

    return isValidGermanPhoneNumber(value) ? null : { invalidPhone: true };
  };
}

export function mobileValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }

    return isValidGermanMobileNumber(value) ? null : { invalidPhone: true };
  };
}
